import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function upgrade() {
  return (
    <section className="upgrade p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className=" my-auto">
            <h2>The Result</h2>
            <p>
              TeeMates, as it was supposed to be, matched our overall quality
              standards and passed the testing phase as smoothly as we had
              envisioned. It is now a bug-free, golf networking platform with
              intuitive interface, one-touch functionality and a marketplace
              that’s becoming more popular each day.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Contact Us
            </Link>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1 "
          >
            <div className="upgrade_img_1">
              <StaticImage
                src="../../../images/case-studies/teemates/result_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={631}
                height={736}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default upgrade;
